module.exports = __webpack_public_path__ + "img/386.3ba2262f.jpg";